import { BlockStack, Box, Card, InlineStack, Layout, Page, Text } from '@shopify/polaris'
import i18next from 'i18next'

const ErrorPage = () => {
  return (
    <div className="error-page">
      <Page narrowWidth>
        <Layout>
          <Layout.Section>
            <Box>
              <Card>
                <InlineStack gap="600">
                  <BlockStack gap="600" align="center">
                    <Text as="h3" variant="headingXl">
                      {i18next.t('errorPageTitle')}
                    </Text>
                    <Text as="p" variant="bodyLg" tone="subdued">
                      {i18next.t('errorPageDescription')}
                    </Text>
                  </BlockStack>
                </InlineStack>
              </Card>
            </Box>
          </Layout.Section>
        </Layout>
      </Page>
    </div>
  )
}

export { ErrorPage }
